<template>
  <div class="content">
    <h1 class="title">{{ $t("usedTickets.title") }}</h1>
    <div class="table">
      <div id="table-list">
        <v-data-table
          v-if="!isLoading"
          :headers="headers"
          :items="list"
          disable-sort
          hide-default-footer
          :items-per-page="-1"
          class="elevation-0"
        >
          <template v-slot:headers="{ columns }">
            <tr>
              <template v-for="column in columns" :key="column.key">
                <th class="text-left header-text">
                  {{ column.title }}
                </th>
              </template>
            </tr>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ dateTimeFormat(item.columns.date_of_usage) }}</td>
              <td>{{ item.columns.par_name }}</td>
              <td>{{ item.columns.product_name }}</td>
              <td>{{ item.columns.full_name }}</td>
              <td>{{ item.columns.used_by }}</td>
              <td>{{ $t(`statuses.${item.columns.status}`) }}</td>
              <td>{{ item.columns.note }}</td>
            </tr>
          </template>
          <template v-slot:no-data>
            <Vue3Lottie
              :animationData="NoDataLottie"
              :height="200"
              :width="200"
            />
            <div class="pb-5 table-no-data">
              <h3>{{ $t("tableNoDataTitle") }}</h3>
              <p>{{ $t("tableNoDataDesc") }}</p>
            </div>
          </template>
          <template v-slot:bottom>
            <div class="botSide">
              <v-row align="center" justify-sm="end" justify="center" class="px-2">
                <v-col cols="12" xs="12" lg="3" md="4" sm="6">
                  <v-row align="center" justify="end"
                    ><div class="pr-2 pageSelectorLabel">
                      {{ $t("usedTickets.tableFooterText") }}
                    </div>
                    <v-select
                      v-model="limit"
                      hide-details
                      @update:model-value="handleFilter(false)"
                      :items="pageSizes"
                      class="pageSelector pl-5"
                    ></v-select>
                    <div class="pl-2">
                      {{ displayRange }}
                    </div>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  lg="3"
                  md="4"
                  sm="5"
                  class="plrde-1 pr-1 pagination"
                >
                  <v-pagination
                    v-model="page"
                    :length="pageCount"
                    rounded="circle"
                    :total-visible="1"
                    show-first-last-page="true"
                    @update:model-value="handleFilter(true)"
                  ></v-pagination>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-data-table>
      </div>
      <v-card v-if="isLoading" class="loading">
        <v-progress-circular
          v-if="isLoading"
          size="73.5"
          indeterminate
          class="loading-circle"
        ></v-progress-circular>
      </v-card>
    </div>
  </div>
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import NoDataLottie from "@/assets/lotties/nodatalottie.json";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "UsedTickets",
  props: {},
  components: {
    Vue3Lottie,
  },
  data() {
    return {
      NoDataLottie,
      headers: [
        {
          title: this.$t("usedTickets.table.headers.date_of_usage"),
          key: "date_of_usage",
          align: "start",
          sortable: false,
        },
        {
          title: this.$t("usedTickets.table.headers.par_name"),
          key: "par_name",
          sortable: false,
        },
        {
          title: this.$t("usedTickets.table.headers.product_name"),
          key: "product_name",
          sortable: false,
        },
        {
          title: this.$t("usedTickets.table.headers.full_name"),
          key: "full_name",
          sortable: false,
        },
        {
          title: this.$t("usedTickets.table.headers.used_by"),
          key: "used_by",
          sortable: false,
        },
        {
          title: this.$t("usedTickets.table.headers.status"),
          key: "status",
          sortable: false,
        },
        {
          title: this.$t("usedTickets.table.headers.note"),
          key: "note",
          sortable: false,
        },
      ],

      //Pagination settings
      page: 1,
      limit: 5,
      total: 0,
      pageSizes: [10, 25, 50, 100],

      isLoading: false,
      error: false,

      list: [],
    };
  },
  created() {
    this.getUsedTicketsMethod();
  },

  methods: {
    ...mapActions({
      getPartners: "users/getPartners",
      getUsedTickets: "users/getUsedTickets",
    }),

    getUsedTicketsMethod(params) {
      this.isLoading = true;
      this.getUsedTickets(params)
        .then((res) => {
          this.list = res.list;

          this.total = res.total;
          this.limit = res.limit;
          this.page = res.page;

          this.isLoading = false;
        })
        .catch(() => (this.isLoading = false));
      this.total = this.list.length;
    },

    handleFilter(hasPage) {
      const params = {
        limit: this.limit,
        page: hasPage ? this.page : 1,
      };
      this.getUsedTicketsMethod(params);
    },

    dateTimeFormat(dateTime) {
      return moment(dateTime).format("YYYY.MM.DD HH:mm:ss");
    },
  },

  computed: {
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
    displayRange() {
      const start = (this.page - 1) * this.limit + 1;
      const end = Math.min(start + this.limit - 1, this.total);
      return `${start}-${end} of ${this.total}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-text {
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #000000de !important;
}
</style>
